module.exports = require("sync-request");


/*****************
 ** WEBPACK FOOTER
 ** external "sync-request"
 ** module id = 14
 ** module chunks = 0
 **/